import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useTranslator } from "@jutro/locale";
import {
  ViewModelForm,
  withViewModelService,
} from "@xengage/gw-portals-viewmodel-react";

import metadata from "./MLEsignaturePolChangeComponent.metadata.json5";
import messages from "./MLEsignaturePolChangeComponent.messeges";
import { MLScriptComponent } from "ml-components-common-react";
import { LoadSaveService } from "gw-capability-gateway-quoteandbind";
import { useAuthentication } from "@xengage/gw-digital-auth-react";
import styles from "./MLEsignaturePolChangeComponent.module.scss";

function MLEsignaturePolChangeComponent(props) {
  const { model: submissionVM, viewModelService, updateWizardData } = props;

  const translator = useTranslator();
  const { authHeader } = useAuthentication();
  const [scriptML, updateScriptML] = useState([]);

  const statusTypeList = viewModelService.productMetadata
    .get("pc")
    .types.getTypelist("ESignatureOptions_Ext");

  const isModernProduct = _.get(
    submissionVM,
    "isModernProduct_Ext.value",
    false,
  );

  const getValueCode = (value) => {
    return _.isObject(value) ? value.code : value;
  };

  const getVMValue = (path) => {
    return _.get(submissionVM, `${path}.value`);
  };

  const setVMValue = (path, value) => {
    _.set(submissionVM, `${path}.value`, value);
  };

  const ensureESignatureML = () => {
    const esignatureMLValue = _.get(submissionVM, "esignature_ML.value");

    if (_.isUndefined(esignatureMLValue) || _.isNull(esignatureMLValue)) {
      _.set(submissionVM, "esignature_ML.value", {});
    }
  };

  const formatPhoneNumber = (number) => {
    if (_.isNil(number)) {
      return number;
    }

    const cleanedNumber = String(number).replace(/\D/g, "").slice(0, 10);

    if (cleanedNumber.length !== 10) {
      return number;
    }

    const area = cleanedNumber.substring(0, 3);
    const front = cleanedNumber.substring(3, 6);
    const end = cleanedNumber.substring(6, 10);

    return `${area}-${front}-${end}`;
  };

const getESignOptions = () => {
    const allowedValues = ["Text", "Email"];

    return statusTypeList.codes
      .filter((option) => allowedValues.includes(option.code))
      .map((option) => ({
        code: option.code,
        name: translator({
          id: option.name,
          defaultMessage: option.name,
        }),
      }));
  };

  const esignValue = getValueCode(getVMValue("esignature_ML.esign_Ext"));

  const esignOptionValue = getValueCode(
    getVMValue("esignature_ML.esignatureOptions"),
  );

  const mobileValue = formatPhoneNumber(
    getVMValue("esignature_ML.mobileNumber_Ext"),
  );

  useEffect(() => {
    const stateCode =
      _.get(submissionVM, "baseData.policyAddress.state.value.code") ||
      _.get(submissionVM, "baseData.policyAddress.state.value") ||
      _.get(submissionVM, "policyAddress.state.value.code") ||
      _.get(submissionVM, "policyAddress.state.value");

    if (!stateCode) {
      return;
    }

    LoadSaveService.getScript(
      "paAdditionalInfoPreBind",
      {
        state: stateCode,
      },
      authHeader,
    ).then((lines) => {
      updateScriptML(lines);
    });
  }, [authHeader, submissionVM]);

  const overrideProps = {
    esignHeading: {
      content: translator(messages.esignHeading),
    },

    esign: {
      label: translator(messages.esign),
      path: "esignature_ML.esign_Ext",
      value: esignValue,
      onValueChange: (value) => {
        ensureESignatureML();

        setVMValue("esignature_ML.esign_Ext", value);

        if (!value) {
          setVMValue("esignature_ML.esignatureOptions", undefined);
          setVMValue("esignature_ML.mobileNumber_Ext", undefined);
          setVMValue("esignature_ML.esignTextAck_Ext", undefined);
        }

        updateWizardData(submissionVM);
      },
    },

    esignOptions: {
      label: translator(messages.esignOptions),
      path: "esignature_ML.esignatureOptions",
      availableValues: getESignOptions(),
      value: esignOptionValue,
      visible: !!esignValue,
      onValueChange: (value) => {
        ensureESignatureML();

        setVMValue("esignature_ML.esignatureOptions", value);

        if (getValueCode(value) !== "Text") {
          setVMValue("esignature_ML.mobileNumber_Ext", undefined);
          setVMValue("esignature_ML.esignTextAck_Ext", undefined);
        }

        updateWizardData(submissionVM);
      },
    },

    esignOptiontMobileNumber: {
      label: translator(messages.esignOptionMobileNumber),
      path: "esignature_ML.mobileNumber_Ext",
      visible: esignOptionValue === "Text",
      required: esignOptionValue === "Text",
      value: mobileValue,
      onValueChange: (value) => {
        ensureESignatureML();

        setVMValue("esignature_ML.mobileNumber_Ext", formatPhoneNumber(value));

        updateWizardData(submissionVM);
      },
    },

    mlScriptComponent: {
      visible:
        isModernProduct && !_.isEmpty(scriptML) && esignOptionValue === "Text",
      mlScript: scriptML,
      isAdditionalInfo:true
    },

    acknowledgementRadioButton: {
      visible:
        isModernProduct && !_.isEmpty(scriptML) && esignOptionValue === "Text",
      path: "esignature_ML.esignTextAck_Ext",
      value: getVMValue("esignature_ML.esignTextAck_Ext"),
      onValueChange: (value) => {
        ensureESignatureML();

        if (!value) {
          setVMValue("esignature_ML.esignatureOptions", "Email");
          setVMValue("esignature_ML.mobileNumber_Ext", undefined);
        }

        setVMValue("esignature_ML.esignTextAck_Ext", value);

        updateWizardData(submissionVM);
      },
    },
  };

  const resolvers = {
    resolveComponentMap: {
      mlScriptComponent: MLScriptComponent,
    },
    resolveClassNameMap: styles,
  };

  return (
    <ViewModelForm
      uiProps={metadata.componentContent}
      overrideProps={overrideProps}
      componentMap={resolvers.resolveComponentMap}
      classNameMap={resolvers.resolveClassNameMap}
      model={submissionVM}
    />
  );
}

export default withViewModelService(MLEsignaturePolChangeComponent);
